// Helpers partagés du blog (Blog.js, Article.js, back-office /blogs).
// Source de vérité des catégories : le vocabulaire contrôlé, aligné sur le
// backend (app/schemas/article.py: CATEGORIES).
import { ARTICLE } from '../constants/colors';

export const CATEGORIES = ['Cycle', 'Sport', 'Mental', 'Nutrition', 'Bien-être', 'Santé'];

// Couleur de badge par catégorie. On lit les variables CSS de thème injectées
// (injectCSSColors) quand elles existent, sinon une couleur de la palette ARTICLE.
const CATEGORY_COLORS = {
  Cycle: 'var(--phase-primary)',       // rouge
  Sport: 'var(--sport-primary)',       // bleu-violet
  Mental: 'var(--mental-primary)',     // rose
  Nutrition: ARTICLE.fitnessBadge,     // teal
  'Bien-être': 'var(--phase-ovulation)', // ambre
  'Santé': 'var(--phase-luteale)',     // violet
};

export const getBadgeColor = (categorie) => CATEGORY_COLORS[categorie] || 'var(--color-primary)';

// Gradient décoratif du hero, dérivé de l'id de façon déterministe.
export const getCardGradient = (id) => {
  const gradients = ARTICLE.cardGradients;
  const hash = String(id).split('').reduce((acc, c) => acc + c.charCodeAt(0), 0);
  return gradients[hash % gradients.length];
};

// Pictogramme de repli quand l'article n'a pas d'image de couverture : posé sur
// le dégradé, il donne un visuel identifiable plutôt qu'un bloc de couleur nu.
const CATEGORY_GLYPHS = {
  Cycle: '🌸',
  Sport: '🏃',
  Mental: '🧠',
  Nutrition: '🥗',
  'Bien-être': '🌿',
  'Santé': '🩺',
};

export const getCategoryGlyph = (categorie) => CATEGORY_GLYPHS[categorie] || '📖';

const MONTHS_FR = [
  'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
  'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre',
];

// "2025-10-12" → "12 octobre". Parsing manuel pour éviter les décalages de fuseau.
export const formatDate = (isoDate) => {
  if (!isoDate) return '';
  const [y, m, d] = String(isoDate).split('-').map(Number);
  if (!y || !m || !d) return '';
  return `${d} ${MONTHS_FR[m - 1]}`;
};

// minutes → "6 min" (court) ou "6 min de lecture" (long).
export const formatReadTime = (minutes, long = false) =>
  `${minutes} min${long ? ' de lecture' : ''}`;
